import styled from 'styled-components';

export const FormWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 1rem;
  margin-bottom: 1.5rem;
`;

export const FormFieldsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;

export const GroupWrapper = styled.div`
  margin-top: 1rem;
`;

export const GroupWrapperStyled = styled.div`
  margin-top: 1rem;
  padding: 0.75rem;
  background-color: #f2eff4;
  border: 1px solid #d8d8d8;
`;

export const GroupTitle = styled.div`
  margin: 0.75rem 0;
  color: #49166d;
  font-size: 1.2rem;
`;

export const RepeatedFormGroup = styled.div`
  background: #f2eff4;
  padding: 1rem 2rem;
  border: 1px solid #d8d8d8;
  margin-top: 2rem;
`;

export const RepeatedFormTitle = styled.div`
  margin: 1rem 0;
  color: #54595f;
  font-size: 1rem;
  font-weight: 500;
`;

/* UDS Typography's variant={{bold:true}} routes bold through a fontFamily swap with no
   matching @font-face, so it never visually renders bold - force it with !important,
   which beats Typography's own inline font-weight/font-size (ExpandCollapse section titles). */
export const SectionHeaderTitle = styled.div`
  span,
  div {
    font-weight: 700 !important;
    font-size: 18px !important;
  }
`;

export const SummaryGroupWrapper = styled.div`
  display: grid;
  grid-template-columns: 2fr 5fr;
  align-items: center;
  border: 1px solid #eaeaea;
  border-radius: 5px;
  margin-top: 0.5rem;
`;

export const SummaryCategory = styled.div`
  color: #ababab;
  padding: 10px;
  background: #f7f7f8;
`;

export const SummaryDetail = styled.div`
  padding: 10px;
  background: #ffffff;
`;

// Wraps each optional summary section (e.g. Hardware/Add-ons/Order Now in the
// IoT view-order popup). Several of these sections render `null` when the
// order has no data for them, but still need SOME margin when they do render
// content - `:empty` collapses that margin for the sections with no content
// instead of leaving a tall blank gap between the sections that do.
export const SummarySectionWrapper = styled.div`
  margin: 1rem 0;
  &:empty {
    margin: 0;
  }
`;

export const ModalFormWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Button = styled.button`
  margin: 0.5em auto;
  width: 20%;
`;

export const ButtonsWrapper = styled.div`
  margin-bottom: 3em;
`;

export const SeatDetailsButtonWrapper = styled.div`
  position: fixed;
  bottom: 0;
  background: #fff;
  width: 100%;
  left: 0;
  padding: 1.5rem 1rem;
  border-top: 5px solid #4b286d;
  z-index: 1;
`;

export const SearchWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  padding: 16px 0;
  @media screen and (max-width: 992px) {
    justify-content: flex-start;
  }
`;

export const TableWrapper = styled.div`
  border: 1px solid #9a9a9a;
  width: 50%;
  max-height: 300px;
  /* higher specificity + !important needed to beat the global ".expand div { overflow: visible !important }" rule */
  && {
    overflow-y: auto !important;
  }
`;

export const BoxWrapper = styled.div`
  display: flex;
  padding: 1rem 0;
`;

export const FormTitle = styled.div`
  font-size: 32px;
  margin-left: 2%;
  margin-bottom: 20px;
`;
